// @flow
import React, { useContext } from 'react';
import { DeleteRenderer } from '@components/views/grid-utils/renderers';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';
import { FRONT_END_DISPLAY_NAMES } from '@streaming-projects/enums';
import { SPStreamGovernanceWorkloadDeleteWarningModal } from '@streaming-projects/workloads/stream-governance-workloads/delete/SPStreamGovernanceWorkloadDeleteWarningModal';

export const SPStreamGovernanceWorkloadDeleteRenderer = ({ data }) => {
  const spStreamingProjectData = useContext(SPStreamingProjectContext);
  return (
    <DeleteRenderer>
      {(isDeleteModalOpen, setDeleteModalOpen) => {
        return (
          <SPStreamGovernanceWorkloadDeleteWarningModal
            isOpen={isDeleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            spVersion={spStreamingProjectData?.sp?.version}
            streamGovernanceWorkloadId={data[FRONT_END_DISPLAY_NAMES.WORKLOAD_ID]}
            streamGovernanceWorkloadName={data[FRONT_END_DISPLAY_NAMES.WORKLOAD_NAME]}
            streamGovernanceWorkloadResourceId={data[FRONT_END_DISPLAY_NAMES.RESOURCE_ID]}
          />
        );
      }}
    </DeleteRenderer>
  );
};
